import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar';
import ld from '../../images/load.gif';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { setdata } from '../../redux/reducers/userSlice';
import styles from '../../styles/profile.module.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Profile() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [isVerified, setIsVerified] = useState(false);

  const dispatch = useDispatch();
  const { users } = useSelector((state) => state);

  useEffect(() => {
    if (users?.userdata) {
      setName(users.userdata.name || '');
      setEmail(users.userdata.email || '');
      setIsVerified(users.userdata.isVerified || false);
    }
  }, [users]);

  const validate = () => {
    if (!name || !name.trim()) {
      toast.error('Please provide your name', {
        position: 'bottom-right',
        theme: 'colored'
      });
      return false;
    }
    if (name.trim().length < 2) {
      toast.error('Name must be at least 2 characters long', {
        position: 'bottom-right',
        theme: 'colored'
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = validate();
    
    if (isValid) {
      try {
        setLoading(true);
        const res = await axios.put('https://chatting-club-backend.onrender.com/api/users/profile', {
          name: name.trim()
        });
        setLoading(false);
        
        if (res.data.success === true) {
          dispatch(setdata(res.data.user));
          
          if (res.data.user) {
            setName(res.data.user.name);
            setEmail(res.data.user.email);
            setIsVerified(res.data.user.isVerified || false);
          }
          
          toast.success('✅ Profile updated successfully!', {
            position: 'bottom-right',
            theme: 'colored'
          });
        } else {
          toast.error(res.data.message || 'Failed to update profile', {
            position: 'bottom-right',
            theme: 'colored'
          });
        }
      } catch (error) {
        setLoading(false);
        const errorMessage = error.response?.data?.message || 'Something went wrong. Please try again.';
        toast.error(errorMessage, {
          position: 'bottom-right',
          theme: 'colored'
        });
      }
    }
  };

  return (
    <div className={styles.profileContainer}>
      <div className={styles.profileWrapper}>
        <div className={styles.profileCard}>
          <div className={styles.profileHeader}>
            <div className={styles.avatarContainer}>
              <div className={styles.avatar}>
                {name ? name.charAt(0).toUpperCase() : 'U'}
              </div>
              <div className={styles.verifiedBadge}>
                {isVerified ? '✅' : '⏳'}
              </div>
            </div>
            <div className={styles.headerInfo}>
              <h2 className={styles.userName}>{name || 'User'}</h2>
              <p className={styles.userEmail}>{email}</p>
              <span className={isVerified ? styles.verifiedStatus : styles.unverifiedStatus}>
                {isVerified ? '✓ Email Verified' : '⚠️ Email Not Verified'}
              </span>
            </div>
          </div>

          <div className={styles.profileBody}>
            <h4 className={styles.sectionTitle}>Edit Profile</h4>
            <form className={styles.profileForm} onSubmit={handleSubmit}>
              <div className={styles.formGroup}>
                <label htmlFor="myemail" className={styles.formLabel}>
                  Email Address
                </label>
                <input
                  id="myemail"
                  className={`${styles.formInput} ${styles.disabledInput}`}
                  value={email}
                  type="email"
                  disabled
                  readOnly
                />
                <small className={styles.helperText}>Email cannot be changed</small>
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="myname" className={styles.formLabel}>
                  Full Name
                </label>
                <input
                  id="myname"
                  className={styles.formInput}
                  value={name}
                  autoComplete="off"
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  placeholder="Enter your full name"
                  required
                />
              </div>

              {loading ? (
                <button className={styles.submitBtn} disabled>
                  <img className={styles.loaderImg} src={ld} alt="loader" />
                  <span>Updating...</span>
                </button>
              ) : (
                <button type="submit" className={styles.submitBtn}>
                  Update Profile
                </button>
              )}
            </form>
          </div>
        </div>

        <div className={styles.statsCard}>
          <h4 className={styles.sectionTitle}>Account Overview</h4>
          <div className={styles.statsGrid}>
            <div className={styles.statItem}>
              <div className={styles.statIcon}>📧</div>
              <div className={styles.statInfo}>
                <span className={styles.statLabel}>Email</span>
                <span className={styles.statValue}>{email}</span>
              </div>
            </div>
            <div className={styles.statItem}>
              <div className={styles.statIcon}>👤</div>
              <div className={styles.statInfo}>
                <span className={styles.statLabel}>Display Name</span>
                <span className={styles.statValue}>{name || 'Not set'}</span>
              </div>
            </div>
            <div className={styles.statItem}>
              <div className={styles.statIcon}>🔐</div>
              <div className={styles.statInfo}>
                <span className={styles.statLabel}>Account Status</span>
                <span className={isVerified ? styles.verifiedStat : styles.unverifiedStat}>
                  {isVerified ? 'Verified' : 'Pending Verification'}
                </span>
              </div>
            </div>
            <div className={styles.statItem}>
              <div className={styles.statIcon}>🕐</div>
              <div className={styles.statInfo}>
                <span className={styles.statLabel}>Member Since</span>
                <span className={styles.statValue}>
                  {users?.userdata?.createdAt 
                    ? new Date(users.userdata.createdAt).toLocaleDateString('en-US', {
                        month: 'long',
                        year: 'numeric'
                      })
                    : 'N/A'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;